// Local Imports
import auth from './auth';
import category from './category';
import review from './review';
import show from './show';
import user from './user';

export default {
  auth,
  category,
  review,
  show,
  user,
};
